import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";

const ImageUpload = ({
  avatar = false,
  addBtnColor = "primary",
  addBtnClasses = "btn-round",
  changeBtnColor = "primary",
  changeBtnClasses = "btn-round",
  removeBtnColor = "danger",
  removeBtnClasses = "btn-round",
  setFieldValue,
  name,
  value,
  setError,
  defaultImg = defaultImage,
}) => {
  const { t } = useTranslation("common");
  const [imagePreviewUrl, setImagePreviewUrl] = useState(
    value ? value : avatar ? defaultAvatar : defaultImg
  );
  const fileInput = useRef(null);

  const handleImageChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (!file) return;
    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!validTypes.includes(file.type)) {
      setError(t("imageUpload.invalidFormat"));
      return;
    }
    if (file.size > 1 * 1024 * 1024) {
      setError(t("imageUpload.tooLarge"));
      return;
    }
    setError("");
    setImagePreviewUrl(URL.createObjectURL(file));
    setFieldValue(name, file);
  };

  const handleClick = () => {
    fileInput.current.click();
  };

  const handleRemove = () => {
    setImagePreviewUrl(avatar ? defaultAvatar : defaultImage);
    fileInput.current.value = null;
    setFieldValue(name, null);
    setError("");
  };

  return (
    <div className="fileinput text-center">
      <input
        type="file"
        onChange={handleImageChange}
        ref={fileInput}
        accept="image/jpeg, image/jpg, image/png"
        hidden
      />
      <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
        <img src={imagePreviewUrl} alt={t("imageUpload.preview")} />
      </div>
      <div>
        {!value ? (
          <Button
            color={addBtnColor}
            className={addBtnClasses}
            onClick={handleClick}
          >
            {avatar ? t("imageUpload.addPhoto") : t("imageUpload.addImage")}
          </Button>
        ) : (
          <span>
            <Button
              color={changeBtnColor}
              className={changeBtnClasses}
              onClick={handleClick}
            >
              {t("imageUpload.change")}
            </Button>
            {avatar ? <br /> : null}
            <Button
              color={removeBtnColor}
              className={removeBtnClasses}
              onClick={handleRemove}
            >
              <i className="fa fa-times" /> {t("imageUpload.remove")}
            </Button>
          </span>
        )}
      </div>
    </div>
  );
};

ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  setFieldValue: PropTypes.func.isRequired,
  removeBtnClasses: PropTypes.string,
  removeBtnColor: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "success",
    "info",
    "warning",
    "danger",
    "link",
  ]),
  addBtnClasses: PropTypes.string,
  addBtnColor: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "success",
    "info",
    "warning",
    "danger",
    "link",
  ]),
  changeBtnClasses: PropTypes.string,
  changeBtnColor: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "success",
    "info",
    "warning",
    "danger",
    "link",
  ]),
};

export default ImageUpload;
